import type {SVGProps} from 'react';
import {memo} from 'react';

export const DatasetIcon = memo(function DatasetIcon({
  style,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      width="26"
      height="31"
      viewBox="0 0 26 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: 'calc(var(--size, 31px) * 0.84)',
        height: 'var(--size, 31px)',
        ...style,
      }}
      {...props}
    >
      <rect
        x="3.66699"
        y="3.66797"
        width="21.3331"
        height="25.4357"
        rx="6"
        fill="#DEE3EC"
        stroke="#DEE3EC"
        strokeWidth="2"
      />
      <rect
        x="1"
        y="1"
        width="21.3331"
        height="25.4357"
        rx="6"
        fill="white"
        stroke="var(--fly-color-primary)"
        strokeWidth="2"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M9.26924 8.63281V13.9622L5.80566 13.2355L10.2588 16.3846L8.27965 18.3226L13.2276 15.9001L13.9698 18.8071L14.3264 13.9622L17.4334 14.4467L12.7328 11.5397L14.9594 9.11729L10.2588 11.5397L9.26924 8.63281Z"
      />
    </svg>
  );
});
